import PropTypes from "prop-types"
import React from "react"
import logoLg from "../../assets/logo2.svg"
import { graphql, Link, useStaticQuery } from "gatsby"
import { CardsWeAccept } from "../cardsWeAccept/cardsWeAccept"
import { signOutUser } from "../../slices/userSlice"
import { useSelector, useDispatch } from "react-redux"
import { AppButtonAndorid, AppButtoniOS } from "../../pages/download-app"
import PhoneNumber from "../phoneNumber/phoneNumber"
import InboxLink from "../inboxLink/inboxLink"
import PhoneIcon from "../../assets/icons/phone.svg"
import MailIcon from "../../assets/icons/mail.svg"
import "./styles.scss"
import { Col, Container, Row } from "react-bootstrap"
import InstaLogo from "../../assets/instagram_black2.svg"
import BackgroundImage from "gatsby-background-image"
import PublishTimestamp from "./PublishTimestamp"
const pjson = require("../../../package.json")

const Footer = props => {
  const { type, page } = props
  const user = useSelector(state => state.user.data)
  const dispatch = useDispatch()

  const data = useStaticQuery(
    graphql`
      query {
        desktopImage: file(relativePath: { eq: "bg/footer-bg-desktop.jpg" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
              ...GatsbyImageSharpFluidLimitPresentationSize
            }
          }
        }
        mobileImage: file(relativePath: { eq: "bg/footer-bg-mobile.jpg" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 600) {
              ...GatsbyImageSharpFluid_withWebp
              ...GatsbyImageSharpFluidLimitPresentationSize
            }
          }
        }
      }
    `
  )

  const sources = [
    data.mobileImage.childImageSharp.fluid,
    {
      ...data.desktopImage.childImageSharp.fluid,
      media: `(min-width: 576px)`,
    },
  ]

  return (
    <BackgroundImage
      Tag="footer"
      className={"footer"}
      fluid={sources}
      backgroundColor={`#ebebeb`}
    >
      <Container>
        <Row>
          <Col xs={12} sm={2} md={1} lg={1} className={"footer__boatlink"}>
            <Link to="/">
              <img
                src={logoLg}
                alt="BoatLink Company Logo"
                className="footer-logo"
              />
            </Link>
          </Col>
          <Col
            xs={12}
            sm={5}
            md={4}
            lg={4}
            xl={{ span: 5, offset: 1 }}
            className={"footer__menu"}
          >
            <h4>Menu</h4>
            <div>
              <ul>
                {user ? (
                  <li className="nav-item">
                    <InboxLink />
                  </li>
                ) : (
                  <li className="nav-item">
                    <Link to="/login">Login</Link>
                  </li>
                )}
                <li>
                  <Link to="/partner-with-us">Add a boat</Link>
                </li>
                <li>
                  <Link to="/faq">Help</Link>
                </li>
                <li>
                  <Link to="/locations">Locations</Link>
                </li>
                <li>
                  <Link to="/terms">Terms</Link>
                </li>
                <li>
                  <Link to="/privacy">Privacy</Link>
                </li>
                <li>
                  <Link to="/blog">Blog</Link>
                </li>
                {user ? (
                  <>
                    <li className="nav-item">
                      <Link to="/profile/update">Profile</Link>
                    </li>
                    <li className="nav-item">
                      <a
                        onClick={e => {
                          e.preventDefault()
                          dispatch(signOutUser())
                        }}
                      >
                        Logout
                      </a>
                    </li>
                  </>
                ) : null}
              </ul>
            </div>
            <div>
              <a
                href="https://instagram.com/theboatlink"
                target="_blank"
                title="BoatLink Instagram page"
              >
                <img
                  className={"footer__insta"}
                  src={InstaLogo}
                  alt={"BoatLink Instagram account"}
                />
              </a>
            </div>
          </Col>
          <Col xs={12} sm={6} md={5} lg={4}>
            <div className={"footer__contact"}>
              <h4>Get in Touch</h4>
              <ul>
                <li>
                  <img src={MailIcon} />
                  <Link to="/contact">Send a message</Link>
                </li>
                <li>
                  <img src={PhoneIcon} />
                  <PhoneNumber id={"phone-number-footer"} />
                </li>

                {/*<li>*/}
                {/*  <a*/}
                {/*    href="https://www.google.com/maps/place/BoatLink/@43.736799,-79.8467885,9z/data=!3m1!4b1!4m5!3m4!1s0x8e43fd28d078bb17:0xaa1c4c55d3f804a2!8m2!3d43.738168!4d-79.286393"*/}
                {/*    target="_blank"*/}
                {/*    title="BoatLink Google maps"*/}
                {/*  >*/}
                {/*    On the map*/}
                {/*  </a>*/}
                {/*</li>*/}
              </ul>
            </div>
            <div className={"footer__apps"}>
              <ul>
                <li>
                  <AppButtoniOS />
                </li>
                <li>
                  <AppButtonAndorid />
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
      <div className={"footer__bottom"}>
        <Container>
          <Row>
            <Col
              xs={{ span: 12, order: "first" }}
              sm={{ span: 8, order: "last" }}
              md={{ span: 9, order: "last" }}
            >
              <CardsWeAccept />
            </Col>
            <Col
              className={"footer__copyright"}
              xs={{ span: 12, order: "last" }}
              sm={{ span: 4, order: "first" }}
              md={{ span: 3, order: "first" }}
            >
              <div>
                <CopyrightNotice />
              </div>
              <div>
                <small
                  style={{
                    fontSize: 10,
                  }}
                >
                  <b>V.{pjson.version}</b>, <PublishTimestamp />
                </small>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </BackgroundImage>
  )
}
Footer.propTypes = {
  siteTitle: PropTypes.string,
}
Footer.defaultProps = {
  siteTitle: ``,
}
export default Footer

const CopyrightNotice = () => {
  const currentYear = new Date().getFullYear()

  return <small>&copy; {currentYear} BoatLink.</small>
}
